import { VgApiResult, vgApiRequest } from "./vg-api.service";

export type SelfProfile = {
  userId: number;
  emailAddress: string;
  contactFirstName: string;
  contactLastName: string;
  languageKey: string;
};

// Maps ENUM_SYS_LanguageKey integer values to canonical string codes (read path)
const ENUM_TO_LANG_KEY: Record<number, string> = {
  2: "en",
  3: "sv",
  4: "pt",
};

// Maps canonical string codes to ENUM_SYS_LanguageKey integer values (write path)
const LANG_KEY_TO_ENUM: Record<string, number> = {
  en: 2,
  en_gb: 2,
  sv: 3,
  pt: 4,
};

function pickUser(data: Record<string, unknown> | null | undefined): Partial<SelfProfile> {
  if (!data) return {};
  const rawLang = data.languageKey ?? data.LanguageKey;
  const asInt = Number(rawLang);
  const languageKey =
    !isNaN(asInt) && ENUM_TO_LANG_KEY[asInt]
      ? ENUM_TO_LANG_KEY[asInt]
      : typeof rawLang === "string"
      ? rawLang
      : "en";
  return {
    userId: Number(data.userId ?? data.UserId ?? 0),
    emailAddress: String(data.emailAddress ?? data.EmailAddress ?? ""),
    contactFirstName: String(data.contactFirstName ?? data.ContactFirstName ?? ""),
    contactLastName: String(data.contactLastName ?? data.ContactLastName ?? ""),
    languageKey,
  };
}

export async function readSelfProfile(
  accessToken: string
): Promise<VgApiResult<SelfProfile>> {
  const { data, error } = await vgApiRequest<Record<string, unknown>>(
    accessToken,
    "Read_Self_Profile",
    {}
  );
  if (error) return { data: null, error };
  const p = pickUser(data);
  return {
    data: {
      userId: p.userId ?? 0,
      emailAddress: p.emailAddress ?? "",
      contactFirstName: p.contactFirstName ?? "",
      contactLastName: p.contactLastName ?? "",
      languageKey: p.languageKey ?? "en",
    },
    error: null,
  };
}

export async function updateUserProfile(
  accessToken: string,
  payload: {
    userId: number;
    emailAddress: string;
    contactFirstName: string;
    contactLastName: string;
    languageKey: string;
  }
): Promise<VgApiResult<unknown>> {
  return vgApiRequest(accessToken, "Update_User_Profile", {
    userId: payload.userId,
    emailAddress: payload.emailAddress,
    contactFirstName: payload.contactFirstName,
    contactLastName: payload.contactLastName,
    userFirstName: payload.contactFirstName,
    userLastName: payload.contactLastName,
    languageKey: LANG_KEY_TO_ENUM[payload.languageKey] ?? 2,
  });
}
